import itFlag from "assets/flags/it.svg";
import enFlag from "assets/flags/gb.svg";
import esFlag from "assets/flags/es.svg";

export enum LanguageValues {
  it = "it",
  en = "en",
  es = "es",
}

export interface ILanguage {
  value: LanguageValues;
  label: string;
  icon: string;
}

export default class Language implements ILanguage {
  value: LanguageValues;
  label: string;
  icon: string;

  constructor(obj: ILanguage) {
    Object.assign(this, obj);
  }

  static getFlagIconByLanguageValue(languageValue: LanguageValues): string {
    switch (languageValue) {
      case LanguageValues.en:
        return enFlag;
      case LanguageValues.it:
        return itFlag;
      case LanguageValues.es:
        return esFlag;
    }
  }

  static getLanguageNameByLanguageValue(languageValue: LanguageValues): string {
    switch (languageValue) {
      case LanguageValues.en:
        return "English";
      case LanguageValues.it:
        return "Italian";
      case LanguageValues.es:
        return "Spanish";
    }
  }
}
